<template>
  <CardContainer :cardTitle="title" :isEmptyData="isLoaded && words != null && words.length === 0" :titleId="'word-cloud-chart-' + index" :participantName="dataParticipantName" :primaryColor="primaryColor" :choosenAnswers="choosenAnswers">
    <b-row slot="body" class="full-height">
      <b-colxx md="10" class="p-0">
        <vue-word-cloud style="height:100%;width:100%;" :words="words" :font-size-ratio="5" font-family="Roboto" @update:progress="progressHandler"> </vue-word-cloud>
        <loader v-if="progress && !containerLoaded">
          <div slot="percentage">{{ progress.completedWords }}/{{ progress.totalWords }}</div>
        </loader>
      </b-colxx>
      <ChartLegend :participantName="dataParticipantName" :primaryColor="primaryColor"></ChartLegend>
    </b-row>
  </CardContainer>
</template>
<script>
import * as d3 from "d3";
import loader from "../../../../loader/bar-loader";
import CardContainer from "./card-container";
import { generateWordCloud, shadeColor } from "../../services/utils";
import ChartLegend from "./chart-legend-card";
export default {
  props: {
    index: [String, Number],
    title: { type: String, default: "Default Title" },
    isLoaded: { type: Boolean, default: false },
    dataSources: [Array, null],
    primaryColor: { type: String, default: "" },
    dataParticipantName: { type: String, default: "" }
  },
  components: {
    CardContainer,
    loader,
    ChartLegend
  },
  data() {
    return {
      words: null,
      color: [],
      choosenAnswers: [],
      progress: undefined,
      containerLoaded: undefined,
      colorLegendOthers: shadeColor(this.primaryColor, 30)
    };
  },
  methods: {
    progressHandler(e) {
      this.progress = e;
      if (e && e.completedWords === e.totalWords) {
        this.containerLoaded = true;
      }
    },
    processVisualization() {
      const { words, colors, choosenAnswers } = generateWordCloud(this.dataSources, this.primaryColor);
      const objectWords = [];
      const tempFullArray = [];
      words.map(item => {
        tempFullArray.push(item[1]);
      });
      const minArray = Math.min(...tempFullArray);
      const maxArray = Math.max(...tempFullArray);
      const myScale = d3
        .scaleLinear()
        .domain([0, 10])
        .range([minArray, maxArray]);

      words.forEach(word => {
        let temp = word[1];
        if (temp == minArray) {
          const maxArrayBy4 = maxArray / 4;
          temp = temp + maxArrayBy4;
        }
        objectWords.push({
          text: word[0],
          weight: myScale(temp),
          color: word[2],
          rotation: this.generateRotation()
        });
      });
      this.words = objectWords;
      this.color = colors;
      this.choosenAnswers = choosenAnswers;
    },
    generateRotation() {
      const rotations = [0, 3 / 4];
      const rotation = rotations[Math.floor(Math.random() * rotations.length)];
      return rotation;
    }
  },
  mounted() {
    this.processVisualization();
  }
};
</script>
<style lang="scss" scoped></style>
